/* 🤖 this file was generated by svg-to-ts */
export const matIconChecklist: {
  name: 'checklist';
  data: string;
} = {
  name: 'checklist',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11 2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"/></svg>`
};
